import React from 'react'
import AddingControllerfunc from '../web/AddingControllerfunc'

const index = () => <AddingControllerfunc />

export default index